function formateNum(num) {
  if (!num) num = 0;
  num = num.toFixed(2);
  var c = num.split(".");
  var b = c[0].toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,") + "." + c[1];
  return b;
}
export default formateNum;
